import React, { useState, useEffect } from 'react';
import componentStyles from './parlaySettingsModal.module.css';
import globalStyles from '../globals.module.css';
import { FaTimes } from 'react-icons/fa';

/**
 * ParlaySettingsModal - Modal component for parlay generator configuration
 * Includes slide-up animation on open and slide-down animation on close
 */
const ParlaySettingsModal = ({ isOpen, onClose, children }) => {
    const [isClosing, setIsClosing] = useState(false);
    const [shouldRender, setShouldRender] = useState(false);

    // Handle opening animation
    useEffect(() => {
        if (isOpen) {
            setShouldRender(true);
            setIsClosing(false);
        } else if (shouldRender) {
            // Trigger closing animation when isOpen becomes false
            setIsClosing(true);
            // Wait for animation to complete before unmounting
            const timer = setTimeout(() => {
                setShouldRender(false);
                setIsClosing(false);
            }, 300); // Match animation duration
            return () => clearTimeout(timer);
        }
    }, [isOpen, shouldRender]);

    // Handle closing animation when close button or overlay is clicked
    const handleClose = () => {
        setIsClosing(true);
        // Wait for animation to complete before calling onClose
        setTimeout(() => {
            setShouldRender(false);
            setIsClosing(false);
            onClose();
        }, 300); // Match animation duration
    };

    if (!shouldRender && !isOpen) {
        return null;
    }

    return (
        <div 
            className={`${componentStyles.modalOverlay} ${isClosing ? componentStyles.modalOverlayClosing : componentStyles.modalOverlayOpening}`}
            onClick={handleClose}
        >
            <div 
                className={`${componentStyles.modalContent} ${isClosing ? componentStyles.modalContentClosing : componentStyles.modalContentOpening}`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={componentStyles.modalHeader}>
                    <h2 className={componentStyles.modalTitle}>Parlay Generator Settings</h2>
                    <button
                        type="button"
                        className={`${globalStyles.iconButton} ${globalStyles.squareButton} ${componentStyles.closeButton}`}
                        onClick={handleClose}
                        aria-label="Close parlay settings"
                        title="Close"
                    >
                        <FaTimes />
                    </button>
                </div>
                <div className={componentStyles.modalBody}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default ParlaySettingsModal;
